export interface IconProps {
    className?: string;
    size?: number;
}

/* ── Flow diagram node icons (32x32) ── */

export const SolarIcon = ({ className }: IconProps) => (
    <svg className={className} viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="10" r="3.5"
            stroke="currentColor" strokeWidth="1.4" fill="currentColor" fillOpacity="0.18" />
        <line x1="16" y1="2" x2="16" y2="4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <line x1="10.5" y1="4.5" x2="11.8" y2="5.8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <line x1="21.5" y1="4.5" x2="20.2" y2="5.8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <rect x="4" y="16" width="24" height="10" rx="1.5"
            stroke="currentColor" strokeWidth="1.3" fill="currentColor" fillOpacity="0.08" />
        <line x1="12" y1="16" x2="12" y2="26" stroke="currentColor" strokeWidth="0.7" />
        <line x1="20" y1="16" x2="20" y2="26" stroke="currentColor" strokeWidth="0.7" />
        <line x1="4" y1="21" x2="28" y2="21" stroke="currentColor" strokeWidth="0.7" />
    </svg>
);

export const BatteryIcon = ({ className }: IconProps) => (
    <svg className={className} viewBox="0 0 32 32" fill="none">
        <rect x="6" y="7" width="20" height="20" rx="2.5"
            stroke="currentColor" strokeWidth="1.3" />
        <rect x="12" y="3" width="8" height="4" rx="1"
            stroke="currentColor" strokeWidth="1.1" />
        <path d="M18 13L14 18h4l-4 5"
            stroke="currentColor" strokeWidth="1.3"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const GridIcon = ({ className }: IconProps) => (
    <svg className={className} viewBox="0 0 32 32" fill="none">
        <path d="M16 2L11 12h3v7H8"
            stroke="currentColor" strokeWidth="1.3"
            strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 2L21 12h-3v7h6"
            stroke="currentColor" strokeWidth="1.3"
            strokeLinecap="round" strokeLinejoin="round" />
        <line x1="8" y1="19" x2="8" y2="28"
            stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="24" y1="19" x2="24" y2="28"
            stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="5" y1="28" x2="27" y2="28"
            stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

export const GeneratorIcon = ({ className }: IconProps) => (
    <svg className={className} viewBox="0 0 32 32" fill="none">
        <rect x="5" y="10" width="22" height="14" rx="2"
            stroke="currentColor" strokeWidth="1.3" />
        <circle cx="12" cy="17" r="3"
            stroke="currentColor" strokeWidth="1.2" />
        <line x1="18" y1="15" x2="24" y2="15"
            stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <line x1="18" y1="19" x2="24" y2="19"
            stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <line x1="10" y1="7" x2="22" y2="7"
            stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        <line x1="9" y1="24" x2="9" y2="27"
            stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <line x1="23" y1="24" x2="23" y2="27"
            stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

/* ── KPI card icons (22x22) ── */

export const SufficiencyIcon = ({ size = 22 }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
        <path d="M15 4a8 8 0 1 0 0 14A6 6 0 0 1 15 4z"
            stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

export const ConsumptionIcon = ({ size = 22 }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
        <path d="M11 3a8 8 0 1 1 0 16"
            stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M11 19a8 8 0 1 1 0-16"
            stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeDasharray="2 3" />
        <path d="M8 8l3 3-3 3" stroke="currentColor" strokeWidth="1.2"
            strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 8l-3 3 3 3" stroke="currentColor" strokeWidth="1.2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const SolarDayIcon = ({ size = 22 }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
        <circle cx="11" cy="11" r="4" stroke="currentColor" strokeWidth="1.4" />
        <line x1="11" y1="2" x2="11" y2="5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="11" y1="17" x2="11" y2="20" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="2" y1="11" x2="5" y2="11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="17" y1="11" x2="20" y2="11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="4.9" y1="4.9" x2="7" y2="7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="15" y1="15" x2="17.1" y2="17.1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="4.9" y1="17.1" x2="7" y2="15" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <line x1="15" y1="7" x2="17.1" y2="4.9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

export const ConsoDayIcon = ({ size = 22 }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
        <path d="M13 2L8 12h5l-5 8" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ── Consumption node icon — home/building silhouette ── */
export const ConsumptionNodeIcon = ({ className }: IconProps) => (
    <svg className={className} viewBox="0 0 32 32" fill="none">
        <path d="M5 15L16 5l11 10" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 13v13h16V13" stroke="currentColor" strokeWidth="1.3"
            strokeLinecap="round" strokeLinejoin="round" fill="currentColor" fillOpacity="0.08" />
        <rect x="13" y="17" width="6" height="9" stroke="currentColor" strokeWidth="1.2" />
        <path d="M13 9.5L13 5h4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

